
import Vue from 'vue'
import Router from 'vue-router'


//组件模块

Vue.use(Router)
 
export default new Router({
  routes: [
    {
      path: "*",  //路由全不匹配的情况下，直接是展示首页
      component: resolve => require(['@/components/index/index'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/",
      component: resolve => require(['@/components/index/index'], resolve),
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/search-teacher",
      component: resolve => require(['@/components/search_teacher/search_teacher'], resolve),
      name:"鲸贝英语-查找教师",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/teacher-details",
      component: resolve => require(['@/components/teacher_details/teacher_details'], resolve),
      name:"鲸贝英语-教师详情",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-order",
      component: resolve => require(['@/components/user_center_order/user_center_order'], resolve),
      name:"鲸贝英语-订单管理",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-order-details",
      component: resolve => require(['@/components/order_detail/order_detail'], resolve),
      name:"鲸贝英语-订单详情",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-center-msg",
      component: resolve => require(['@/components/user_center_msg/user_center_msg'], resolve),
      name:"鲸贝英语-短信提醒",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-buy",
      component: resolve => require(['@/components/user_center_buy/user_center_buy'], resolve),
      name:"鲸贝英语-购买学币",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-rights",
      component: resolve => require(['@/components/user_center_rights/user_center_rights'], resolve),
      name:"鲸贝英语-会员权限",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-course",
      component: resolve => require(['@/components/user_center_course/user_center_course'], resolve),
      name:"鲸贝英语-教材推荐",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user/course",
      component: resolve => require(['@/components/user_center_my/user_center_my'], resolve),
      name:"鲸贝英语-我的课程",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-teacher",
      component: resolve => require(['@/components/user_center_teacher/user_center_teacher'], resolve),
      name:"鲸贝英语-我的老师",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-center-info",
      component: resolve => require(['@/components/user_center_info/user_center_info'], resolve),
      name:"鲸贝英语-基本资料",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-center-pwd",
      component: resolve => require(['@/components/user_center_pwd/user_center_pwd'], resolve),
      name:"鲸贝英语-修改密码",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-course-detail",
      component: resolve => require(['@/components/user_course_detail/user_course_detail'], resolve),
      name:"鲸贝英语-课程详情",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user-course-comment",
      component: resolve => require(['@/components/user_course_comment/user_course_comment'], resolve),
      name:"鲸贝英语-课程评价",
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/wxpay",
      component: resolve => require(['@/components/wxpay/wxpay'], resolve),
      name:"鲸贝英语-微信支付",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-benefit",
      component: resolve => require(['@/components/user_benefit/index'], resolve),
      name:"鲸贝英语-邀请福利",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user-point",
      component: resolve => require(['@/components/user_point/index'], resolve),
      name:"鲸贝英语-用户积分",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/public-course",
      component: resolve => require(['@/components/course_public/index'], resolve),
      name:"鲸贝英语-公开课",
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/course-report",
      component: resolve => require(['@/components/class_report/index'], resolve),
      name:"鲸贝英语-学习报告",
      meta: {
        keepAlive: false
      }
    },
  ]
})